(function () {
	'use strict';

	angular.module('app.core')
		.service('siteService', siteService);

	siteService.$inject = ['$http', 'URLS'];

	function siteService($http, URLS) {
		var service = {
			getSiblingSites: getSiblingSites,
			getUsersForSite: getUsersForSite,
			getUserSites: getUserSites,
			getSitesByCustomer: getSitesByCustomer,
			getAdminSitesByCustomer: getAdminSitesByCustomer,
			getCustomersCount: getCustomersCount,
			isAdmin: isAdmin,
			isAdminForSite: isAdminForSite,
			isLeanDNAAdminForSite: isLeanDNAAdminForSite,
			hasAccessForSite: hasAccessForSite,
			canUserEditMetricTargets: canUserEditMetricTargets,
			canUserEditAnyMetric: canUserEditAnyMetric,
			isLeanDNAUser: isLeanDNAUser,
			isWriteBackEnabled: isWriteBackEnabled,
			isWorkbenchSupervisor: isWorkbenchSupervisor,
			isSpiritSupplier: isSpiritSupplier,
			isSpiritUser: isSpiritUser,
			hasRolesSupplier: hasRolesSupplier,
			getUserMaxProfileRank: getUserMaxProfileRank,
			getSomeFactoriesUseConfirmations: getSomeFactoriesUseConfirmations,
			getFactoryUsesConfirmations: getFactoryUsesConfirmations
		};

		return service;

		function getSiblingSites(siteId) {
			var pageUrl = String.format(URLS.siblingSites, siteId || globalConfig.factory.id);
			return $http.get(URLS.host + pageUrl)
				.then(getSiblingSitesComplete)
				.catch(getSiblingSitesFailed);

			function getSiblingSitesComplete(response) {
				return response.data;
			}

			function getSiblingSitesFailed(error) {
				return [];
			}

		}

		function getUsersForSite(siteId, excludeSupplier) {
			var pageUrl = String.format(URLS.usersForSite, siteId, excludeSupplier);
			return $http.get(URLS.host + pageUrl)
				.then(getUsersForSiteSuccess)
				.catch(getUsersForSiteFailed);

			function getUsersForSiteSuccess(response) {
				return response.data;
			}

			function getUsersForSiteFailed(error) {
				return [];
			}
		}

		function getUserSites() {
			var sites = globalConfig.user.authFacts;
			sites = _.filter(globalConfig.user.authFacts, function (factory) {
				return (factory.profileType === 'SystemAdministrator' || factory.profileType === 'SuperSystemAdministrator');
			});

			sites = sites.map(function (site) {
				return {
					'id': site.ndx,
					'factoryName': site.name,
					'name': site.alias || site.name,
					'customerId': site.customerNdx
				};
			});
			return _.sortBy(sites, ['factoryName']);
		}

		function getSitesByCustomer(customerId) {
			var sitesByCustomer = _.filter(globalConfig.user.authFacts, function (factory) {
				return factory.customerNdx === customerId;
			}).map(function (factory) {
				return {
					'id': factory.ndx,
					'name': factory.alias || factory.name
				};
			});
			return _.sortBy(sitesByCustomer, ['name']);
		}

		function getAdminSitesByCustomer(customerId) {
			var sitesByCustomer = _.filter(globalConfig.user.authFacts, function (factory) {
				return factory.customerNdx === customerId && (factory.profileType === 'SystemAdministrator' || factory.profileType === 'SuperSystemAdministrator');
			}).map(function (factory) {
				return {
					'id': factory.ndx,
					'name': factory.alias || factory.name
				};
			});
			return _.sortBy(sitesByCustomer, ['name']);
		}

		function isAdmin() {
			return _.some(globalConfig.user.authFacts, ['profileType', 'SystemAdministrator']);
		}

		function getCustomersCount() {
			return _.size(_.countBy(globalConfig.user.authFacts, 'customerNdx'));
		}

		function isAdminForSite(siteId) {
			var profileType = globalConfig.user.authFacts[siteId] && globalConfig.user.authFacts[siteId].profileType;
			
			return profileType === 'SystemAdministrator'|| profileType === 'SuperSystemAdministrator';
		}

		function isLeanDNAAdminForSite(siteId) {
			return isAdminForSite(siteId) && isLeanDNAUser();
		}

		function hasAccessForSite(siteId) {
			return globalConfig.user.authFacts[siteId];
		}

		function canUserEditMetricTargets() {
			return _.some(globalConfig.user.authFacts, function (factory) {
				return factory.customerNdx === globalConfig.customer.id && factory.canEditAnyMetricTargets;
			});
		}

		function canUserEditAnyMetric() {
			return _.some(globalConfig.user.authFacts, function (factory) {
				return factory.customerNdx === globalConfig.customer.id && factory.canEditAnyMetric;
			});
		}

		function isLeanDNAUser() {
			return globalConfig.user.userName.endsWith('@leandna.com');
		}

		function isWriteBackEnabled() {
			return _.some(globalConfig.user.authFacts, function (factory) {
				return factory.customerNdx === globalConfig.customer.id && factory.isWriteBackEnabled;
			});
		}

		function isWorkbenchSupervisor() {
			return _.some(globalConfig.user.authFacts, function (factory) {
				return factory.customerNdx === globalConfig.customer.id && factory.isWorkbenchSupervisor;
			});
		}
		
		function isSpiritSupplier() {
			return globalConfig.user.role === 'Supplier' && globalConfig.customer.id === 90;
		}

		function isSpiritUser() {
			return globalConfig.customer.id === 90;
		}

		function hasRolesSupplier() {
			return _.some(globalConfig.user.authFacts, function (factory) {
				return factory.roleType === 'Supplier';
			});
		}

		function getUserMaxProfileRank() {
			var maxLevel = _.max(Object.values(globalConfig.user.authFacts).map(function(t) { 
				switch (t.profileType) { 
				case 'ReadWriteUser': return 0;
				case 'SystemAdministrator': return 1;
				case 'SuperSystemAdministrator': return 3; 
				default: return 0;
				}
			}));
			if (maxLevel < 3 && globalConfig.user.isCustomerAdministrator) {
				maxLevel = 2;
			}
			return maxLevel;
		}

		function getSomeFactoriesUseConfirmations() {
			return Object.values(globalConfig.user.authFacts)
				.filter(function (site) { return site.customerNdx === globalConfig.customer.id && site.settings && site.settings.usePoConfirmations === '1'; })
				.map(function(site) { return parseInt(site.ndx); })
				.length > 0;
		}

		function getFactoryUsesConfirmations(siteId) {
			return globalConfig.user.authFacts[siteId].settings && globalConfig.user.authFacts[siteId].settings.usePoConfirmations === '1';
		}
	}
})();
